import styles from "./index.module.less"
import { classModuleGenerator } from "@/utils"
import Enroll from ".//enroll"
import wechat from "@/assets/images/wechat.png"

function Footer() {
  const classnames = classModuleGenerator(styles)

  return (
    <>
      <Enroll />
      <div className={classnames("footer-wrap")}>
        <div className={classnames("clearfix", "foot-upper")}>
          <div className={classnames("section__inner")}>
            <dl
              className={classnames("foot-abbox")}
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              <dt>关于我们</dt>
              <dd>学大全日制</dd>
              <dd>教学管理</dd>
              <dd>班型介绍</dd>
              <dd>合作院校</dd>
              <dd>热门资讯</dd>
            </dl>
            <dl
              className={classnames("foot-abbox")}
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              <dt>普通高考班</dt>
              <dd>艺考升学班</dd>
              <dd>职教高考班</dd>
              <dd>中职就业班</dd>
            </dl>
            <dl
              className={classnames("foot-abbox")}
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              <dt>覆盖城市</dt>
              <dd>广州</dd>
              <dd>西安</dd>
              <dd>呼和浩特</dd>
              <dd>哈尔滨</dd>
              <dd>合肥</dd>
            </dl>
            <dl
              className={classnames("foot-abbox")}
              onClick={() => {
                window.openJesongChatByGroup(121, 52601)
                return false
              }}
            >
              <dt>客服热线</dt>
              <dd>
                <a className={styles.phone} href={"tel: 400-625-4008"}>
                  <img src={require("@/assets/images/icon_phone1.png")} alt="" />
                  400-625-4008
                </a>
              </dd>
              <dd>( 周一至周日 8:00-22:00 )</dd>
              <dd>
                <button>立即咨询</button>
              </dd>
            </dl>
            <div className={classnames("qrcode")}>
              <img src={wechat} alt="" />
              官方微信号
            </div>
          </div>
        </div>
        <div className={classnames("bg-black")}>
          <div className={classnames("section__inner")}></div>
          <div className={classnames("foot-lower")}>
            <div className={classnames("content")}>
              <p className={classnames("str")}>
                全国免费咨询热线：
                <span className={classnames("ftl400")}>400-0524-008</span> |
                咨询时间：8:00-23:00（节假日不休）
              </p>

              <p>
                违法和不良信息举报电话：400-102-8926 举报邮箱：info@xueda.com{" "}
                <a href=" https://www.12377.cn" target="_blank" rel="nofollow">
                  网上有害信息举报专区
                </a>
              </p>
              <p>
                <a
                  href="https://beian.miit.gov.cn/"
                  target="_blank"
                  rel="nofollow noreferrer"
                >
                  京ICP备10045583号-81
                </a>
                学大Xueda.com 版权所有
                <a
                  href="http://file.xueda.com/xueda/yingyezhizhao.jpg"
                  target="_blank"
                  rel="noreferrer"
                >
                  北京学大信息技术集团有限公司
                </a>
                <a
                  href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502031324"
                  target="_blank"
                  rel="nofollow noreferrer"
                >
                  京公网安备 11010502031324号
                </a>
              </p>
              <p>
                增值电信业务经营许可证B2-20212159
                电信与信息服务业务经营许可证京ICP证100956
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
